import Model from "./base/model";

class ProcedaCustomOccurrence extends Model{
  resourceName() {
    return "proceda_custom_occurrences";
  }

  fields() {
    return {
      code:"",
      description:""
    };
  }
}

export default new ProcedaCustomOccurrence();
